
import React, {useState} from "react";
import WorksYiz from "./worksyiz";
import IconsYiz from "./iconsyiz";

import {FaHamburger,FaLightbulb, FaDownload,FaGithub,FaLinkedin,FaEnvelope,FaPhone,FaWhatsapp,FaBars } from "react-icons/fa";
import ContactYiz from "./cotactyiz";
import FooterYiz from "./footeryiz";
import Skills from "./skills";
import Contact from "./contact";
import Donate from "./donate";
import { ArrowRight,ThreeDotsVertical } from 'react-bootstrap-icons';
import Headerstory from "./Headerstory";
function Yiz(props) {
  const [style2, setStyle2] = useState('#F2EFEB');
  const [style3, setStyle3] = useState('black');

  let audio = new Audio("/click2.wav")
  let stop = true;
  
 
  const start = () => {
   
      // stop? audio.play():stop = false;   // must chheck!!!!!!!!!!1
      // stop = false
      audio.play()
  }
 
  const clickmode = ()=>{

    setStyle2(style2 != "black" ? "black" : '#F2EFEB');
      console.log(style2)
    setStyle3(style3 != "black" ? "black" : '#F2EFEB');
      console.log(style3)
    }

  return (
    
    <div id="idborder" className="container-fluid "style={{ background: style2 ,color:style3}} >
       <FaLightbulb  className="display-6 p-1 m-1" onClick={clickmode}/>
      <Headerstory/>
      <Skills/>
      <WorksYiz  />
      <Contact/>
      <Donate/>
      <ContactYiz/>
     
     
 
      <a href="https://github.com/yizfar/" onMouseOver={start}>< FaGithub id="FaGithubid"  className="icon" data-tip=" My Github"/></a>
      <a href="https://www.linkedin.com/in/yizhak-farber/" onMouseOver={start}> < FaLinkedin id="FaLinkedinid"  className="icon"  data-tip="My Linkedin"/></a> 
      <a href="tel:+972548463456"> < FaPhone id="FaPhoneid" className="icon" data-tip="Call Phone" /></a> 
      <a  href="https://wa.me/972548463456" onMouseOver={start}
        class="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"> < FaWhatsapp id="FaWhatsappid"  className="icon"  data-tip="My Whatsapp" /></a> 

        
         <a href="#" onMouseOver={start} > <img src="yizlogo2.png" height="50"   id="topid"   data-tip="Back to top"  /></a>

         <a  href="mailto:yizfar@gmail.com" id="vertiid"   data-tip="Back to top"  onMouseOver={start} ><div className="vl"></div> <span id="vertiid"   data-tip="Send Email " >Yizfar<span id="shtruid">@</span>gmail.com</span></a>
       
         <FooterYiz/>
    </div>
  );
}
{
}

export default Yiz;
